import React, {useCallback} from 'react'
import {ContentTypeUtil} from 'yougile-util'
import {ChatMessageFile} from '@components/common/base/chat-message'
import {usePreview} from '@components/right-panel/chat/chat-messages/message/utils/use-preview'

export const useFileClick = (): ((
  fileData: ChatMessageFile,
  e: React.MouseEvent
) => void) => {
  const preview = usePreview()

  return useCallback(
    ({encoded}: ChatMessageFile, e: React.MouseEvent) => {
      e.stopPropagation()

      const extension = encoded.split('.')?.pop()?.split('?')[0]
      if (extension && ContentTypeUtil.isVideoExtension(extension)) {
        preview(encoded, e)
      }
    },
    [preview]
  )
}
